import { Plus } from 'lucide-react'
import { Link } from 'react-router-dom'

import { ButtonShadow } from './ButtonShadow'

const LANDING_URL = 'https://hodle.com.br'
const APP_URL = 'https://app.hodle.com.br'

export type RoadmapHeaderProps = {
  onSubmitIdea: () => void
}

export const RoadmapHeader = ({
  onSubmitIdea,
}: RoadmapHeaderProps): JSX.Element => (
  <header className="sticky top-0 z-30 border-b border-dune-border bg-dune-bg/80 backdrop-blur">
    <div className="mx-auto flex h-16 w-full max-w-5xl items-center justify-between px-4 sm:px-8">
      <Link to="/" className="flex items-center gap-2.5">
        <img src="/full_hodle.png" alt="Hodle" className="h-9 w-auto" />
        <span className="font-display text-base font-medium text-dune-text-secondary">
          Roadmap
        </span>
      </Link>

      <nav className="flex items-center gap-1 sm:gap-4">
        <a
          href={LANDING_URL}
          target="_blank"
          rel="noreferrer"
          className="hidden font-display text-sm text-dune-text-secondary transition-colors hover:text-dune-text sm:inline"
        >
          Site
        </a>
        <a
          href={APP_URL}
          target="_blank"
          rel="noreferrer"
          className="hidden font-display text-sm text-dune-text-secondary transition-colors hover:text-dune-text sm:inline"
        >
          Abrir app
        </a>

        <ButtonShadow
          faceClassName="border-dune-text bg-white text-dune-text"
          shadowClassName="bg-dune-accent"
          onClick={onSubmitIdea}
        >
          <Plus className="mr-2 h-4 w-4" /> Enviar ideia
        </ButtonShadow>
      </nav>
    </div>
  </header>
)
